<header class="modal-header codigo-conducta-bg">
  <figure class="modal-title text-center w-100 p-5">
    <img class="ml-3" src="../../../../../assets/images/atencion-modal.png" width="100" />
  </figure>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span class="text-white" aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body text-center pl-5 pr-5 pb-5">
  <label class="h5 text-body"><strong>Confirmación</strong></label>
  <p class="text-muted">¿Está seguro que desea finalizar la solicitud?</p>
  <div class="text-center">
      <button class="btn w-25 btn-outline-primary mr-3" (click)="dismiss()">No</button>
    <button class="btn w-25 btn-primary" (click)="confirm()">Si</button>
  </div>
</section>
